import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-rent-details',
    templateUrl: './rent-details.component.html',
    styleUrls: ['./rent-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentDetailsComponent {

}
